import { useAppDispatch, useAppSelector } from "app/hooks";
import { ShowHideFields } from "./components/ShowHideFields";
import Button from "shared/components/Button";
import {
  scoutDateOnClick,
  selectFieldOnClick,
  sphereDateOnClick,
} from "shared/helpers/sharedOnClickFunctions";
import { Transition } from "react-transition-group";
import { TransitionProps } from "react-transition-group/Transition";
import { useRef } from "react";
import useMedia from "use-media";
import { MOBILE_VIEW_BREAKPOINT } from "shared/helpers/mediaQueries";
import { setShowMenus } from "features/settings/details-slice";

/**
 * `$transitionShort` out
 * `$transitionShort` in
 *
 * Same as PageSideMenu
 * Linked to PageSideMenu, KeyButtons, MeasureButtons, Measure
 */
const TIMEOUTS: TransitionProps["timeout"] = {
  enter: 0,
  appear: 300,
  exit: 300,
};

interface PageBottomMenuProps {
  menusInView: boolean;
}

const PageBottomMenu: React.FC<PageBottomMenuProps> = ({ menusInView }) => {
  const showMenusNodeRef = useRef<HTMLDivElement>(null);
  const bottomMenuNodeRef = useRef<HTMLDivElement>(null);
  const largerThanMobileView = useMedia(MOBILE_VIEW_BREAKPOINT);

  const showMenus = useAppSelector((state) => state.settings.showMenus);
  const farmName = useAppSelector(
    (state) => state.panorama.farmDetails?.farmname
  );
  const fieldName = useAppSelector(
    (state) => state.panorama.currentFieldDetails?.title
  );
  const panoDate = useAppSelector(
    (state) => state.panorama.currentFieldDetails?.panodate
  );
  const plantDate = useAppSelector(
    (state) => state.panorama.currentFieldDetails?.plant_date
  );
  // const longDate = useAppSelector(
  //   (state) => state.panorama.currentFieldDetails?.longdate
  // );
  const shortDate = useAppSelector(
    (state) => state.panorama.currentFieldDetails?.shortdate
  );
  const dispatch = useAppDispatch();
  return (
    <>
      <Transition
        nodeRef={showMenusNodeRef}
        in={!showMenus && largerThanMobileView}
        timeout={TIMEOUTS}
        mountOnEnter
        // Can unmount this, but not necessary
        // unmountOnExit
      >
        {(transitionState) => (
          <div
            ref={showMenusNodeRef}
            className={`ShowMenusParent ${transitionState}`}
          >
            <Button
              colour="ThemeAlt"
              additionalClassNames="BtnLink"
              onClick={() => {
                dispatch(setShowMenus(true));
              }}
            >
              Show Menus
            </Button>
          </div>
        )}
      </Transition>
      <Transition
        nodeRef={bottomMenuNodeRef}
        in={menusInView && showMenus && largerThanMobileView}
        timeout={TIMEOUTS}
        mountOnEnter
        // Don't unmount as this is a key component of the UI
        // unmountOnExit
      >
        {(transitionState) => (
          <footer
            ref={bottomMenuNodeRef}
            className={`PageBottomMenu ${transitionState}`}
          >
            {/* LEFT side */}
            <div className="Left DisplayFlex LargeGap">
              <div className="DisplayFlex">
                <span>
                  {farmName} | {fieldName}
                </span>
                <Button
                  colour="ThemeAlt"
                  additionalClassNames="BtnLink"
                  // TEMP: Phase 2 - Field Selector
                  disabled
                  onClick={selectFieldOnClick(dispatch)}
                  children="Select Field"
                />
              </div>
              <div className="DisplayFlex">
                <span>Plant date: {plantDate || "No date"}</span>
              </div>
              <div className="DisplayFlex">
                <span>Sphere date: {panoDate || "No date"}</span>
                <Button
                  colour="ThemeAlt"
                  additionalClassNames="BtnLink"
                  // TEMP: Phase 2 - Sphere selector
                  disabled
                  onClick={sphereDateOnClick(dispatch)}
                  children="Select"
                />
              </div>
              <div className="DisplayFlex">
                <span>Scout date: {shortDate || "No date"}</span>
                <Button
                  colour="ThemeAlt"
                  additionalClassNames="BtnLink"
                  // TEMP: Phase 2 - Sphere selector
                  disabled
                  onClick={scoutDateOnClick(dispatch)}
                  children="Select"
                />
              </div>
            </div>
            {/* RIGHT side */}
            <div className="Right DisplayFlex LargeGap">
              <Button
                colour="ThemeAlt"
                additionalClassNames="BtnLink"
                onClick={() => {
                  dispatch(setShowMenus(false));
                }}
              >
                Hide Menus
              </Button>
              <ShowHideFields />
            </div>
          </footer>
        )}
      </Transition>
    </>
  );
};

export default PageBottomMenu;
